<template>
  <div>
    <div class="row mt-4 mb-4">
      <div class="col-8">
        <div class="custom-switch">
          <input
            type="checkbox"
            class="custom-control-input"
            id="switch-ih2"
            v-model="ih2.all"
            @click="selectAll"
          />
          <label class="custom-control-label" for="switch-ih2">
            {{ $t('menu.settings.users.labels.selectAll') }}
          </label>
        </div>
      </div>
      <div class="col-4">
        <div class="find-ih2-area">
          <input
            type="text"
            class="form-control"
            id="find-ih2"
            :placeholder="`${this.$t(
              'menu.settings.users.placeholderHierarchy',
            )}`"
            v-model="text"
          />
          <button @click="text = null" class="btn btn-outline-primary">
            {{ $t('menu.settings.users.clear') }}
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="table-ih2-permissions">
          <b-table
            id="table-ih2"
            :items="items"
            :fields="fields"
            :busy="loading"
            :per-page="perPage"
            :current-page="currentPage"
            responsive="sm"
            striped
          >
            <template v-slot:table-busy>
              <div class="text-center text-primary my-2">
                <b-spinner type="grow" class="align-middle"></b-spinner>
              </div>
            </template>
            <template v-slot:cell(selected)="row">
              <div style="width: 5px;">
                <div class="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    :id="`input-ih2-${row.item._id}`"
                    :value="row.item._id"
                    class="custom-control-input input-ih2"
                    @click="checkPermission"
                    :checked="check(row.item._id)"
                  />
                  <label
                    class="custom-control-label"
                    :for="`input-ih2-${row.item._id}`"
                  ></label>
                </div>
              </div>
            </template>
            <template v-slot:cell(createdAt)="row">
              <span>{{ dateFormat(row.item.createdAt) }}</span>
            </template>
          </b-table>
          <div class="mt-4 mb-4">
            <b-pagination
              v-model="currentPage"
              :total-rows="total"
              :per-page="perPage"
              aria-controls="table-ih2"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Paginate from 'vuejs-paginate';
import { format } from 'date-fns';
import pt from 'date-fns/locale/pt';

// eslint-disable-next-line
const toLower = (text) => text.toString().toLowerCase();

const searchByName = (items, term) => {
  if (term) {
    // eslint-disable-next-line
    return items.filter((item) =>
      toLower(`${item.corporate_name}`).includes(toLower(term)),
    );
  }

  return items;
};

export default {
  props: { user: { type: Object, required: true } },

  components: {
    Paginate,
  },

  data: () => ({
    userAuth: null,
    loading: true,
    fields: [],
    items: [],
    perPage: 10,
    currentPage: 1,
    text: null,
    total: 0,
  }),

  computed: {
    ...mapFields('branches', ['ih2']),
  },

  methods: {
    ...mapActions('branches', ['getBranchesIH2']),

    dateFormat(param) {
      const date = format(new Date(param), 'dd/MM/yyyy', { locale: pt });
      return date;
    },

    checkPermission(event) {
      if (event.target.checked) {
        this.ih2.selected.push(event.target.value);

        if (this.ih2.selected.length === this.ih2.branches.length) {
          this.ih2.all = true;
        }
      } else {
        this.ih2.all = false;
        this.ih2.selected.splice(
          this.ih2.selected.indexOf(event.target.value),
          1,
        );
      }
    },

    check(id) {
      if (this.ih2.selected.indexOf(id) + 1) {
        return true;
      }
      return false;
    },

    findIH2() {
      if (this.text) {
        const items = searchByName(this.ih2.branches, this.text);
        this.items = items;
      } else {
        this.items = this.ih2.branches;
      }

      this.total = this.items.length;
    },

    async selectAll(event) {
      if (event.target.checked) {
        this.ih2.selected = [];

        this.ih2.branches.forEach((el) => {
          this.ih2.selected.push(el._id);
        });

        await this.selectRows();
      } else {
        this.ih2.selected = [];
        await this.selectRows();
      }
    },

    async selectRows() {
      const inputs = document.querySelectorAll('.input-ih2');

      inputs.forEach((input) => {
        this.ih2.selected.forEach((perm) => {
          if (input.value === perm) {
            input.checked = true;
          }
        });
      });
    },

    async getUserPermissions() {
      if (this.user.ih2) {
        if (this.user.ih2.length > 0) {
          this.user.ih2.forEach((el) => {
            this.ih2.selected.push(el);
          });
        } else if (this.user.companyId._id === this.userAuth.companyId) {
          this.ih2.branches.forEach((el) => {
            this.ih2.selected.push(el._id);
          });
          this.ih2.all = true;
        }
      }
    },

    async updateTable() {
      this.loading = true;

      await this.getBranchesIH2({
        token: this.userAuth.token,
        companyId: this.userAuth.companyId,
      });

      // this.items = this.ih2.branches;

      this.sortBranches(this.ih2.branches);

      this.total = this.ih2.total;

      this.loading = false;
    },

    sortBranches(branches = []) {
      branches.forEach((branch) => {
        const found = this.user.ih2.indexOf(branch._id);

        if (found + 1) {
          this.items.unshift(branch);
        } else {
          this.items.push(branch);
        }
      });
    },
  },

  watch: {
    text: async function watchText() {
      this.findIH2();
    },
  },

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    this.ih2.selected = [];
    this.ih2.all = false;

    await this.updateTable();

    await this.getUserPermissions();

    this.fields = [
      {
        key: 'selected',
        label: this.$t('menu.settings.users.labels.permission'),
      },
      {
        key: 'corporate_name',
        label: this.$t('menu.settings.users.labels.branch'),
        sortable: true,
      },
      {
        key: 'createdAt',
        label: this.$t('menu.settings.users.labels.date'),
        sortable: true,
      },
    ];
  },
};
</script>

<style scoped>
.pag-area-perm-branches >>> a {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #4ce595;
  background-color: #fff;
  border: 1px solid #dee2e6;
}

.options {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.select-all-area {
  background-color: rgba(241, 243, 244, 0.6);
  padding: 10px;
  color: #5f6368;
}

.select-all-clickable {
  color: #1a73e8;
  cursor: pointer;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.find-ih2-area {
  display: flex;
  flex-direction: row;
}
</style>

<style lang="scss">
.table-ih2-permissions {
  table {
    thead {
      tr {
        th:first-child {
          max-width: 50px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/modal-permissions/ih-permissions/index.vue